function toPositiveInt(v: unknown): number | null {
    if (v == null || v === '') return null;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
}

/** Normalize product profile API rows for react-admin forms. */
export function normalizeProductProfileRecord(row: unknown): Record<string, unknown> {
    const o =
        row && typeof row === 'object' && !Array.isArray(row)
            ? { ...(row as Record<string, unknown>) }
            : {};
    const rawId = o.id ?? o.Id;
    const id = rawId != null && rawId !== '' ? rawId : undefined;

    const stockGlAccountId = toPositiveInt(
        o.stockGlAccountId ?? o.StockGlAccountId ?? o.itemStockGl ?? o.ItemStockGl
    );
    const saleGlAccountId = toPositiveInt(
        o.saleGlAccountId ?? o.SaleGlAccountId ?? o.itemSalesGl ?? o.ItemSalesGl
    );
    const costGlAccountId = toPositiveInt(
        o.costGlAccountId ?? o.CostGlAccountId ?? o.itemCostGl ?? o.ItemCostGl
    );
    const primaryDefaultVendorId = toPositiveInt(
        o.primaryDefaultVendorId ?? o.PrimaryDefaultVendorId ?? o.productPartyId ?? o.ProductPartyId
    );

    const defaultVendorIdsRaw = o.defaultVendorIds ?? o.DefaultVendorIds;
    const defaultVendorIds = Array.isArray(defaultVendorIdsRaw)
        ? defaultVendorIdsRaw.map(x => Number(x)).filter(n => Number.isFinite(n) && n > 0)
        : o.defaultVendorIds;

    const defaultTaxIdsRaw = o.defaultTaxIds ?? o.DefaultTaxIds;
    const defaultTaxIds = Array.isArray(defaultTaxIdsRaw)
        ? defaultTaxIdsRaw.map(x => Number(x)).filter(n => Number.isFinite(n) && n > 0)
        : [];

    return {
        ...o,
        ...(id !== undefined ? { id } : {}),
        stockGlAccountId,
        saleGlAccountId,
        costGlAccountId,
        primaryDefaultVendorId,
        defaultVendorIds,
        defaultTaxIds,
        maintainInventory: o.maintainInventory === true || o.MaintainInventory === true,
    };
}

export function transformProductProfileWrite(data: Record<string, unknown>): Record<string, unknown> {
    const stockGlAccountId = toPositiveInt(
        data.stockGlAccountId ?? data.StockGlAccountId ?? data.itemStockGl
    );
    const saleGlAccountId = toPositiveInt(data.saleGlAccountId ?? data.SaleGlAccountId ?? data.itemSalesGl);
    const costGlAccountId = toPositiveInt(data.costGlAccountId ?? data.CostGlAccountId ?? data.itemCostGl);
    const primaryDefaultVendorId = toPositiveInt(
        data.primaryDefaultVendorId ?? data.PrimaryDefaultVendorId ?? data.productPartyId
    );

    const defaultVendorIdsRaw = data.defaultVendorIds ?? data.DefaultVendorIds;
    const defaultVendorIds = Array.isArray(defaultVendorIdsRaw)
        ? defaultVendorIdsRaw.map(x => Number(x)).filter(n => Number.isFinite(n) && n > 0)
        : undefined;

    const defaultTaxIdsRaw = data.defaultTaxIds ?? data.DefaultTaxIds;
    const defaultTaxIds = Array.isArray(defaultTaxIdsRaw)
        ? defaultTaxIdsRaw.map(x => Number(x)).filter(n => Number.isFinite(n) && n > 0)
        : [];

    return {
        ...data,
        maintainInventory: data.maintainInventory === true,
        stockGlAccountId,
        saleGlAccountId,
        costGlAccountId,
        primaryDefaultVendorId,
        ...(defaultVendorIds !== undefined ? { defaultVendorIds } : {}),
        defaultTaxIds,
    };
}
